import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/about')({
  component: About,
});

function About() {
  return (
    <div className="mx-auto max-w-5xl px-6 py-10 prose prose-sm dark:prose-invert">
      <h1>About Wharf Mail</h1>
      <p>
        Wharf Mail is a collaborative email client for teams. Connect a personal or shared
        Gmail account, comment on threads with your team, assign messages to teammates,
        and tag conversations for follow-up.
      </p>
      <p>
        Today Wharf Mail supports Gmail accounts only. More providers (and AI assistance for
        drafting, summarising, and routing) are on the roadmap.
      </p>
    </div>
  );
}
